import ContentWikiPages from './content-wiki-pages'

export default ContentWikiPages
